export default __webpack_public_path__ + "static/1.1_DE-0dfc10ac4bbacb5e4bc7b1528f8c5486.webp";